import React from "react";

const AboutSoftwareServices = ({ features }) => (
    <section data-bs-version="5.1" className="features13 cid-software-enhanced" id="features13-software">
        <div className="container">
            <div className="row justify-content-center align-items-center">
                <div className="col-12 col-lg-6 mb-5 mb-lg-0">
                    <div className="card-wrapper fade-in-left">
                        <div className="card-box align-left">
                            <h4 className="card-title mbr-fonts-style mb-4 display-2">
                                <strong>ИТ-услуги и решения</strong>
                            </h4>
                            <p className="mbr-text mbr-fonts-style mb-4 display-7">
                                Мы предлагаем комплексные услуги в сфере разработки, поддержки и внедрения программных решений, включая работу с пространственными данными и консалтинг.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    {features.map((feature, index) => (
                        <div className="item features-without-image fade-in-up" key={index}>
                            <div className="item-wrapper glass-card">
                                <div className="icon-box shadow-lg">
                                    <span className={`mbr-iconfont ${feature.icon}`}></span>
                                </div>
                                <div className="text-box">
                                    <h4 className="icon-title mbr-black mbr-fonts-style display-7">
                                        <strong>{feature.title}</strong>
                                    </h4>
                                    <h5 className="icon-text mbr-black mbr-fonts-style display-4">
                                        {feature.text}
                                    </h5>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default AboutSoftwareServices;
